import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NHADisplayFadeInOutAnimationDirective } from './display-fade-in-out.animation';

export const DIRECTIVES = [NHADisplayFadeInOutAnimationDirective];

@NgModule({
	imports: [CommonModule, ...DIRECTIVES],
	exports: [...DIRECTIVES]
})
export class NHAAnimationDirectivesModule {}
